<template>
  <v2-modal
    :show="show"
    title="Collection schedule"
    size="lg"
    @close="$emit('close')"
  >
    <div class="v2-schedule-collection">
      <div class="v2-schedule-collection__brand-name">
        {{ brandDetails.entityName }}
      </div>
      <div
        v-if="!isSubscribed"
        class="v2-schedule-collection__subtitle"
      >
        Follow the brand and you'll be notified as soon as the latest collection goes live
      </div>
      <div
        v-else
        class="v2-schedule-collection__subtitle"
      >
        You will receive notifications about all new collections.
      </div>
      <div class="v2-schedule-collection__grid">
        <div
          v-for="month in monthsWithCollection"
          :key="month.LABEL"
          class="v2-schedule-collection__month"
          :class="{ 'v2-schedule-collection__month--active': month.seasonType }"
        >
          <div class="v2-schedule-collection__month-header">
            {{ month.TEXT }}
          </div>
          <div class="v2-schedule-collection__month-body">
            {{ scheduledCollectionTypes[month && month.seasonType] }}
          </div>
        </div>
      </div>
      <div
        v-if="!isSubscribed"
        class="v2-schedule-collection__action"
      >
        <v2-button @click="$emit('handle-subscription')">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          Follow Brand
        </v2-button>
      </div>
    </div>
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'

export default {
  name: 'V2ScheduleCollectionModal',
  components: { V2Modal, V2Button },
  props: {
    show: { type: Boolean, default: false },
    brandDetails: { type: Object, default: () => ({}) },
    monthsWithCollection: { type: Array, default: () => [] },
    isSubscribed: { type: Boolean, default: false },
    scheduledCollectionTypes: { type: Object, default: () => ({}) },
  },
}
</script>

<style lang="scss" scoped>
.v2-schedule-collection {
  text-align: center;

  &__brand-name {
    font-family: var(--v2-font-sans);
    font-size: 1rem;
    font-weight: 400;
    color: var(--v2-foreground);
    margin-bottom: var(--v2-space-1);
  }

  &__subtitle {
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    color: var(--v2-muted-foreground);
    margin-bottom: var(--v2-space-6);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: var(--v2-space-2);
  }

  &__month {
    background: var(--v2-muted);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    min-height: 120px;

    &--active {
      background: var(--v2-secondary);
    }
  }

  &__month-header {
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--v2-foreground);
    padding: var(--v2-space-3) var(--v2-space-3) 0;
  }

  &__month-body {
    font-family: var(--v2-font-sans);
    font-size: 0.8125rem;
    color: var(--v2-foreground);
    padding: var(--v2-space-2) var(--v2-space-3) var(--v2-space-3);
  }

  &__action {
    display: flex;
    justify-content: center;
    margin-top: var(--v2-space-6);
  }
}
</style>
